import { Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  actionButtonsRenderer,
  textRenderer,
} from "../Common/DataTable/CellRenderers";
import { formatInAppNotificationExpiry } from "../../utils/inAppNotificationUtils";

export const createInAppNotificationColumns = (handlers, { compact = false } = {}) => {
  const { onEdit, onView, onDelete, canEdit = true, canDelete = true } = handlers;

  const actions = [
    {
      id: "view",
      icon: VisibilityIcon,
      tooltip: "View details",
      variant: "info",
      onClick: (row) => onView(row),
    },
    ...(canEdit
      ? [
          {
            id: "edit",
            icon: EditIcon,
            tooltip: "Edit notification",
            variant: "primary",
            onClick: (row) => onEdit(row),
          },
        ]
      : []),
    ...(canDelete && onDelete
      ? [
          {
            id: "delete",
            icon: DeleteIcon,
            tooltip: "Delete notification",
            variant: "danger",
            onClick: (row) => onDelete(row),
          },
        ]
      : []),
  ];

  return [
    {
      key: "title",
      label: "Title",
      sortable: false,
      minWidth: compact ? 140 : 180,
      render: textRenderer,
    },
    ...(compact
      ? []
      : [
          {
            key: "type",
            label: "Content Layout",
            sortable: true,
            minWidth: 110,
            render: textRenderer,
          },
        ]),
    {
      key: "expiry",
      label: "Expiry",
      sortable: true,
      minWidth: compact ? 120 : 140,
      render: (value) => (
        <Typography variant="body2">{formatInAppNotificationExpiry(value)}</Typography>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      align: "center",
      justifyContent: "center",
      minWidth: compact ? 112 : 130,
      render: actionButtonsRenderer(actions),
    },
  ];
};
